<template>
  <div>
    <div
      v-if="sectionLoading"
      class="m-[40px] animate-pulse text-gray-500 text-md font-bold flex flex-col justify-center items-center"
    >
      <div class="mb-5">
        <div
          style="border-top-color: transparent"
          class="ml-5 w-8 h-8 border-4 border-gray-600 border-solid rounded-full animate-spin"
        ></div>
      </div>
      <div>Loading ...</div>
    </div>
    <!-- section name input field -->
    <form v-else class="w-full mt-4">
      <div
        v-if="
          getBasicAttributes ? Object.keys(getBasicAttributes).length : null
        "
        class="flex items-center justify-left px-4"
      >
        <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2">
          <AttrTitleWithDescription
            :title="'Create a new instance '"
            :description="'create new instance or select an exist instance'"
          />
        </label>
        <ToggleBtn
          class="m-4"
          :status="blogComponent['shouldCreate']"
          @update:status="handleUpdateStatus($event)"
        />
      </div>
      <div
        v-if="
          getBasicAttributes ? Object.keys(getBasicAttributes).length : null
        "
        class="flex flex-wrap"
      >
        <transition
          enter-active-class="duration-300 ease-out"
          enter-from-class="transform opacity-0"
          enter-to-class="opacity-100"
          leave-active-class="duration-200 ease-in"
          leave-from-class="opacity-100"
          leave-to-class="transform opacity-0"
          mode="out-in"
        >
          <div
            v-if="blogComponent['shouldCreate'] === 'yes'"
            class="w-full lg:w-4/12 px-4"
          >
            <div class="relative w-full mb-3">
              <label
                class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="'Section Name'"
                  :description="'The name of the section ( each section name should be unique in this page )'"
                />
              </label>
              <input
                @focus="sectionNameValidator"
                type="text"
                v-model="blogComponent['name']"
                :class="
                  sectionNameExist
                    ? 'border-red-500 placeholder-red-300 border-1 border-solid focus:ring-red-500'
                    : 'border-0'
                "
                class="px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              />
            </div>
          </div>
          <div v-else class="w-full lg:w-4/12 px-4">
            <div class="relative w-full mb-3">
              <label
                class="flex items-center block uppercase text-blueGray-600 text-xs font-bold mb-2"
              >
                <AttrTitleWithDescription
                  :title="'Select Instance'"
                  :description="'Select one exist instance'"
                />
                <div
                  v-if="getBlogInstancesLoading[componentId]"
                  style="border-top-color: transparent"
                  class="ml-5 w-4 h-4 border-4 border-gray-300 border-solid rounded-full animate-spin"
                ></div>
                <p
                  v-if="getBlogInstancesLoading[componentId]"
                  class="text-sm text-gray-300 ml-2"
                >
                  Loading ...
                </p>
              </label>
              <select
                v-model="selectedInstance"
                class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              >
                <option
                  v-for="(option, index) in instanceOptions"
                  :key="index"
                  :value="option.value"
                >
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>
        </transition>
      </div>
      <hr
        v-if="getBasicAttributes && Object.keys(getBasicAttributes).length"
        class="mt-2 border-b-1 border-gray-100"
      />
      <h6
        v-if="
          getBasicAttributes ? Object.keys(getBasicAttributes).length : null
        "
        class="text-blueGray-400 text-sm mt-3 ml-4 mb-6 font-bold uppercase"
      >
        Basic
      </h6>
      <div class="flex flex-wrap">
        <div
          v-for="(value, name) in getBasicAttributes"
          :key="name"
          class="w-full lg:w-4/12 px-4"
        >
          <div v-if="value.type === 'short_text'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              type="text"
              v-model="blogComponent['attributes'][name]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
          <div
            v-else-if="value.type === 'select' || value.type === 'boolean'"
            class="relative w-full mb-3"
          >
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <select
              v-model="blogComponent['attributes'][name]"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            >
              <option
                v-for="(option, index) in changeOptionsFormat(value.options)"
                :key="index"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
          <div v-else-if="value.type === 'url'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <URLInput
              :url="
                blogComponent['attributes'][name]
                  ? blogComponent['attributes'][name]
                  : ''
              "
              @update:url="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else-if="value.type === 'icon'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <IconPicker
              :icons="value.options"
              :icon="
                blogComponent['attributes'][name]
                  ? blogComponent['attributes'][name]
                  : ''
              "
              @update:icon="(val) => handleUpdateValue(val, name)"
            />
          </div>
          <div v-else class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <input
              v-model="blogComponent['attributes'][name]"
              type="text"
              class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
            />
          </div>
        </div>
      </div>
      <hr
        v-if="
          getAdditionalAttributes && Object.keys(getAdditionalAttributes).length
        "
        class="mt-6 border-b-1 border-gray-200"
      />
      <h6
        v-if="
          getAdditionalAttributes
            ? Object.keys(getAdditionalAttributes).length
            : null
        "
        class="text-blueGray-400 text-sm mt-3 ml-4 mb-6 font-bold uppercase"
      >
        Additional
      </h6>
      <div
        v-if="
          getAdditionalAttributes
            ? Object.keys(getAdditionalAttributes).length
            : null
        "
        class="flex flex-wrap"
      >
        <div
          v-for="(value, name) in getAdditionalAttributes"
          :key="name"
          class="w-full lg:w-12/12 px-4"
        >
          <div v-if="value.type === 'long_text'" class="relative w-full mb-3">
            <label
              class="block uppercase text-blueGray-600 text-xs font-bold mb-2"
            >
              <AttrTitleWithDescription
                :title="formatAttrName(name)"
                :description="value.description"
              />
            </label>
            <ckeditor
              class="h-40 border-0 px-3 py-3 placeholder-blueGray-300 bg-white rounded shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
              :editor="editor"
              :config="editorConfig"
              v-model="blogComponent['attributes'][name]"
            />
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import AttrTitleWithDescription from "@/components/Shared/Headers/AttrTitleWithDescription";
import { mapGetters } from "vuex";
import ToggleBtn from "@/components/Shared/Input/ToggleBtn";
import CKEditor from "@ckeditor/ckeditor5-vue";
import ClassicEditor from "@/assets/ckeditor/build/ckeditor";
import * as Actions from "@/store/actions.type";
import * as Constants from "@/store/constants";
import URLInput from "@/components/Shared/Input/URLInput";
import IconPicker from "@/components/Shared/Input/IconPicker";

export default {
  name: "BlogSection",
  components: {
    URLInput,
    ckeditor: CKEditor.component,
    IconPicker,
    ToggleBtn,
    AttrTitleWithDescription
  },
  data() {
    return {
      sectionNameExist: false,
      editor: ClassicEditor,
      editorConfig: Constants.CK_EDITOR_CONFIG
    };
  },
  props: {
    formData: {
      type: Object,
      required: true
    },
    validationStatus: {
      type: Boolean,
      required: true
    },
    index: { type: Number, required: true }
  },
  computed: {
    instanceSelected() {
      if (
        this.componentId &&
        this.selectedInstance &&
        this.getBlogComponentInstances[this.componentId] &&
        Object.keys(this.getBlogComponentInstances[this.componentId]).length
      ) {
        return this.getBlogComponentInstances[this.componentId].find(
          (instance) => instance.instance_name === this.selectedInstance
        );
      } else {
        return {};
      }
    },
    componentAttrs() {
      if (this.getBlogComponentAttrs[this.index]) {
        return this.getBlogComponentAttrs[this.index];
      } else {
        return {};
      }
    },
    selectedInstance: {
      get: function () {
        return this.getBlogSelectedInstance[this.index];
      },
      set: function (val) {
        this.$store.dispatch(Actions.SET_SELECTED_BLOG_INSTANCE, {
          instanceId: val,
          index: this.index
        });
      }
    },
    instanceOptions() {
      if (
        this.getBlogComponentInstances[this.componentId] &&
        Object.keys(this.getBlogComponentInstances[this.componentId]).length
      ) {
        return this.getBlogComponentInstances[this.componentId].map((item) => {
          const instanceName = item.instance_name.split("|")[1];
          return { label: instanceName, value: item.instance_name };
        });
      } else {
        return [];
      }
    },
    blogSectionName() {
      return `${
        this.getComponentId(this.blogComponent["component"]) || ""
      }|blog_${this.blogComponent["name"] || ""}`;
    },
    blogTitle() {
      return this.formDataLocal["blog"]["abi_blog_title"];
    },
    sectionLoading() {
      return this.getBlogComponentLoading[this.index];
    },
    componentId() {
      return this.getComponentId(this.blogComponent["component"]);
    },
    blogComponent: {
      get: function () {
        if (this.formDataLocal["components"][this.index]) {
          return this.formDataLocal["components"][this.index];
        } else {
          return {
            attributes: {},
            component: "",
            componentId: "",
            name: "",
            id: "",
            shouldCreate: "yes"
          };
        }
      },
      set: function (val) {
        this.formDataLocal["components"][this.index] = val;
      }
    },
    getBasicAttributes() {
      let formatObject = {};
      if (this.getBlogComponentAttrs[this.index]) {
        formatObject = JSON.parse(
          JSON.stringify(this.getBlogComponentAttrs[this.index])
        );
        for (const item in formatObject) {
          if (formatObject[item].type === "long_text") {
            delete formatObject[item];
          }
        }
        return formatObject;
      } else {
        return [];
      }
    },
    getAdditionalAttributes() {
      let formatObject = {};
      if (this.getBlogComponentAttrs[this.index]) {
        formatObject = JSON.parse(
          JSON.stringify(this.getBlogComponentAttrs[this.index])
        );
        for (const item in formatObject) {
          if (formatObject[item].type !== "long_text") {
            delete formatObject[item];
          }
        }
        return formatObject;
      } else {
        return [];
      }
    },
    validationStatusLocal: {
      get: function () {
        return this.validationStatus;
      },
      set: function (val) {
        this.$emit("update:validationStatus", val);
      }
    },
    formDataLocal: {
      get: function () {
        return this.formData;
      },
      set: function (val) {
        this.$emit("update:formData", val);
      }
    },
    ...mapGetters([
      "getBlogComponentLoading",
      "getAllComponent",
      "getBlogComponentAttrs",
      "getBlogComponentInstances",
      "getBlogInstancesLoading",
      "getBlogSelectedInstance",
      "getRegion"
    ])
  },
  mounted() {
    // fetch blog section attributes
    if (!this.getAllComponent.length) {
      this.$store.dispatch(Actions.FETCH_ALL_COMPONENT, {
        region: this.getRegion,
        hardRefresh: false
      });
    } else if (this.componentId) {
      this.$store.dispatch(Actions.FETCH_BLOG_COMPONENT_ATTR, {
        region: this.getRegion,
        componentId: this.componentId,
        index: this.index
      });
    }

    // fill in component id when component name exist
    if (this.blogComponent.component) {
      this.blogComponent.componentId = this.getComponentId(
        this.blogComponent.component
      );
    }

    // fetch instance data
    this.$store.dispatch(Actions.FETCH_BLOG_COMPONENT_INSTANCE, {
      region: this.getRegion,
      componentId: this.componentId
    });
  },
  watch: {
    instanceSelected() {
      // fill in the form with instance data
      this.setInstanceValue();
      if (this.instanceSelected) {
        this.blogComponent.id = this.instanceSelected.id;
      }
    },
    // fill in the form with initial value
    componentAttrs() {
      this.setInitialValue();
    },
    selectedInstance() {
      const componentList =
        this.formDataLocal["blog"]["abi_blog_components"].split(",");
      componentList[this.index] = this.selectedInstance;
      this.formDataLocal["blog"]["abi_blog_components"] =
        componentList.join(",");
    },
    // fetch the component attributes
    componentId() {
      if (this.componentId) {
        this.$store.dispatch(Actions.FETCH_BLOG_COMPONENT_ATTR, {
          region: this.getRegion,
          componentId: this.componentId,
          index: this.index
        });
      }
      if (
        this.blogComponent["shouldCreate"] === "no" &&
        !this.getBlogComponentInstances[this.componentId]
      ) {
        this.$store.dispatch(Actions.FETCH_BLOG_COMPONENT_INSTANCE, {
          region: this.getRegion,
          componentId: this.componentId
        });
      }
    },
    // fill in component id when component name changed
    "blogComponent.component"() {
      if (this.blogComponent.component) {
        this.blogComponent.componentId = this.getComponentId(
          this.blogComponent.component
        );
      }
    },
    // fetch component instance when user want to select exist instances
    "blogComponent.shouldCreate"() {
      // fill in forms when switch toggle
      if (this.blogComponent["shouldCreate"] === "no") {
        this.setInstanceValue();
      } else if (this.blogComponent["shouldCreate"] === "yes") {
        this.setInitialValue();
      }
    },
    // check whether name exist when change section name
    "blogComponent.name"() {
      this.sectionNameValidator();
    },
    "formDataLocal.blog.abi_blog_components"() {
      this.sectionNameValidator();
    }
  },
  methods: {
    setInitialValue() {
      if (
        this.componentAttrs &&
        Object.keys(this.componentAttrs).length &&
        this.blogComponent["shouldCreate"] === "yes"
      ) {
        const initialAttributes = {};
        Object.keys(this.componentAttrs).forEach((item) => {
          let value = this.componentAttrs[item];
          initialAttributes[item] = value.value;
        });
        this.blogComponent.attributes = initialAttributes;
      }
    },
    setInstanceValue() {
      if (
        this.instanceSelected &&
        Object.keys(this.instanceSelected).length &&
        this.blogComponent["shouldCreate"] === "no"
      ) {
        this.blogComponent.attributes = this.instanceSelected.attributes;
      } else {
        this.blogComponent.attributes = {};
      }
    },
    sectionNameValidator() {
      if (this.blogComponent["name"]) {
        // *** VALIDATOR: check whether the section name show up more than one time
        let componentList = this.formData.blog.abi_blog_components.split(",");
        if (
          componentList.filter((item) => {
            return item === this.blogSectionName;
          }).length > 1
        ) {
          this.sectionNameExist = true;
          this.$store.dispatch(Actions.SET_BLOG_ERRORS, {
            error: "Blog sections cannot have same name! "
          });
          this.validationStatusLocal = false;
        } else if (this.getBlogComponentInstances[this.componentId]) {
          // *** VALIDATOR: check whether section name exist
          for (let item of this.getBlogComponentInstances[this.componentId]) {
            if (item.instance_name === this.blogSectionName) {
              this.sectionNameExist = true;
              this.$store.dispatch(Actions.SET_BLOG_ERRORS, {
                error: "Blog sections name already exist!"
              });
              this.validationStatusLocal = false;
              break;
            } else {
              this.sectionNameExist = false;
              this.$store.dispatch(Actions.CLEAR_BLOG_ERRORS);
              this.validationStatusLocal = true;
            }
          }
        }
      }
    },
    formatAttrName(name) {
      const nameArray = name.split("_");
      nameArray.splice(0, 2);
      return nameArray.join(" ");
    },
    changeOptionsFormat(options) {
      const newOptions = options.map((item) => {
        return { label: item, value: item };
      });
      return newOptions;
    },
    handleUpdateValue(val, name) {
      this.blogComponent["attributes"][name] = val;
    },
    handleUpdateStatus(val) {
      this.blogComponent["shouldCreate"] = val;
    },
    getComponentId(componentName) {
      if (this.getAllComponent.find((item) => item.name === componentName)) {
        return this.getAllComponent.find((item) => item.name === componentName)
          .id;
      } else {
        return null;
      }
    }
  }
};
</script>
